import { Fragment } from "react";

import HeroBanner from "../components/Layout/SaaSLandingPage/HeroBanner/HeroBanner";
import Headline from "../components/Layout/SaaSLandingPage/Body/Headline";
import Testimonials from "../components/Layout/SaaSLandingPage/Testimonials/Testimonials";
import OurMembers from "../components/Layout/SaaSLandingPage/Members/OurMembers";
import Benefits from "../components/Layout/SaaSLandingPage/Benefits/Benefits";
import Mastermind from "../components/Layout/SaaSLandingPage/Mastermind/Mastermind";
import Difficulties from "../components/Layout/SaaSLandingPage/Difficulties/Difficulties";
import PDFViewer from "../components/Layout/SaaSLandingPage/Resources/PDFViewer";

import { createSidetab } from "@typeform/embed";
import "@typeform/embed/build/css/sidetab.css";

const options = {
  buttonText: "Join waitlist",
  customIcon: "💯",
};

const SaaSLandingPage = () => {
  createSidetab("qXnRr9dp", options);

  return (
    <Fragment>
      <HeroBanner />
      <OurMembers />
      <Testimonials />
      <Headline />
      <Difficulties />
      <Mastermind />
      <Benefits />
      <PDFViewer />
    </Fragment>
  );
};

export default SaaSLandingPage;
